import { render, staticRenderFns } from "./AppCollapse.vue?vue&type=template&id=424c575e&scoped=true"
import script from "./AppCollapse.vue?vue&type=script&lang=js"
export * from "./AppCollapse.vue?vue&type=script&lang=js"
import style0 from "./AppCollapse.vue?vue&type=style&index=0&id=424c575e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "424c575e",
  null
  
)

export default component.exports